module.exports = __webpack_public_path__ + "static/media/icon_arrow_bottom.779fac93.svg";